import React from 'react';
import { FISHERMAN_BRAND, GLAMMATIC_BRAND } from './FishermanBanner.constants';
import { getBrandUrl, getBrandLogo, getBrandLogoClassName } from './FishermanBanner.utils';
import OutboundLink from '../../atoms/OutboundLink';
import './FishermanBanner.css';
var defaultProps = {
  backgroundColor: 'black',
  brand: FISHERMAN_BRAND,
  className: ''
};
export default function FishermanBanner(_ref) {
  var backgroundColor = _ref.backgroundColor,
    brand = _ref.brand,
    className = _ref.className;
  var brandUrl = getBrandUrl(brand);
  var brandLogoClassName = getBrandLogoClassName(brand);
  var BrandLogo = getBrandLogo(brand);
  return /*#__PURE__*/React.createElement("div", {
    className: "fisherman-banner ".concat(className),
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/React.createElement(OutboundLink, {
    to: brandUrl
  }, /*#__PURE__*/React.createElement("span", null, "Powered by"), /*#__PURE__*/React.createElement(BrandLogo, {
    className: brandLogoClassName
  })));
}
FishermanBanner.defaultProps = defaultProps;